export const P = {
  bg: "#FAFBFE",
  text: "#1C1B29",
  sub: "#524D68",
  dim: "#6E6A82",
  faint: "#8A86A0",
  border: "#E8E5F0",
  nodes: ["#4D8A8A", "#5E6AAE", "#8B7BC2", "#B06B7D", "#5E8A6A", "#7B6BA0"],
};

export const H = { fontFamily: "'Fraunces', Georgia, serif" };
export const HD = { fontFamily: "'Geist', 'Helvetica Neue', sans-serif", fontWeight: 600, letterSpacing: "-0.01em" };
export const B = { fontFamily: "'Geist', 'Helvetica Neue', sans-serif" };

export const PD = {
  bg:        "#0C0E1A",
  bgSurface: "#141628",
  bgCard:    "#1C1E34",
  bgGlow:    "#22243E",
  text:      "#E4DED4",
  sub:       "#A8A098",
  dim:       "#68625C",
  faint:     "#403C38",
  border:    "#28263C",
  borderLit: "#383650",
  thread:    "#4A4658",
};

export const SC = {
  accent:       "#68B8C8",
  accentBright: "#88D0DC",
  accentNeed:   "#9878C8",
  wheel:        "#E4DED430",
  aspectWarm:   "#C0904C40",
  aspectCool:   "#68B8C840",
};
